import { c as _c } from "react/compiler-runtime";
import { TodoListProps } from "@/types";
import { useState, useEffect } from "react";
import { TodoItem } from "./TodoItem";
import { useUIStore } from "@/stores/use-ui-store";
export function TodoList(t0) {
  const $ = _c(40);
  const {
    todos,
    onToggle,
    onDelete,
    onUnarchive,
    onEdit,
    handleEditTodo,
    cancelEditing
  } = t0;
  const [isMobile, setIsMobile] = useState(false);
  const editingTodoId = useUIStore(_temp);
  const editText = useUIStore(_temp2);
  const editEmoji = useUIStore(_temp3);
  const editTime = useUIStore(_temp4);
  const setEditText = useUIStore(_temp5);
  const setEditEmoji = useUIStore(_temp6);
  const setEditTime = useUIStore(_temp7);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const checkIfMobile = () => {
        setIsMobile(window.innerWidth < 768);
      };
      checkIfMobile();
      window.addEventListener("resize", checkIfMobile);
      return () => window.removeEventListener("resize", checkIfMobile);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] !== editingTodoId || $[3] !== setEditTime || $[4] !== todos) {
    t3 = () => {
      if (editingTodoId) {
        const todo = todos.find(t => t.id === editingTodoId);
        setEditTime(todo?.time || "");
      }
    };
    t4 = [editingTodoId, todos, setEditTime];
    $[2] = editingTodoId;
    $[3] = setEditTime;
    $[4] = todos;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== cancelEditing || $[8] !== editEmoji || $[9] !== editText || $[10] !== editTime || $[11] !== editingTodoId || $[12] !== handleEditTodo || $[13] !== isMobile || $[14] !== onDelete || $[15] !== onEdit || $[16] !== onToggle || $[17] !== onUnarchive || $[18] !== setEditEmoji || $[19] !== setEditText || $[20] !== setEditTime || $[21] !== todos) {
    let t6;
    if ($[23] !== cancelEditing || $[24] !== editEmoji || $[25] !== editText || $[26] !== editTime || $[27] !== editingTodoId || $[28] !== handleEditTodo || $[29] !== isMobile || $[30] !== onDelete || $[31] !== onEdit || $[32] !== onToggle || $[33] !== onUnarchive || $[34] !== setEditEmoji || $[35] !== setEditText || $[36] !== setEditTime) {
      t6 = todo_0 => <TodoItem key={todo_0.id} todo={todo_0} isEditing={editingTodoId === todo_0.id} editText={editText} editEmoji={editEmoji} editTime={editTime} isMobile={isMobile} onToggle={onToggle} onDelete={onDelete} onUnarchive={onUnarchive} onEdit={onEdit} setEditText={setEditText} setEditEmoji={setEditEmoji} setEditTime={setEditTime} handleEditTodo={handleEditTodo} cancelEditing={cancelEditing} />;
      $[23] = cancelEditing;
      $[24] = editEmoji;
      $[25] = editText;
      $[26] = editTime;
      $[27] = editingTodoId;
      $[28] = handleEditTodo;
      $[29] = isMobile;
      $[30] = onDelete;
      $[31] = onEdit;
      $[32] = onToggle;
      $[33] = onUnarchive;
      $[34] = setEditEmoji;
      $[35] = setEditText;
      $[36] = setEditTime;
      $[37] = t6;
    } else {
      t6 = $[37];
    }
    t5 = todos.map(t6);
    $[7] = cancelEditing;
    $[8] = editEmoji;
    $[9] = editText;
    $[10] = editTime;
    $[11] = editingTodoId;
    $[12] = handleEditTodo;
    $[13] = isMobile;
    $[14] = onDelete;
    $[15] = onEdit;
    $[16] = onToggle;
    $[17] = onUnarchive;
    $[18] = setEditEmoji;
    $[19] = setEditText;
    $[20] = setEditTime;
    $[21] = todos;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[38] !== t5) {
    t6 = <>{t5}</>;
    $[38] = t5;
    $[39] = t6;
  } else {
    t6 = $[39];
  }
  return t6;
}
function _temp7(state_5) {
  return state_5.setEditTime;
}
function _temp6(state_4) {
  return state_4.setEditEmoji;
}
function _temp5(state_3) {
  return state_3.setEditText;
}
function _temp4(state_2) {
  return state_2.editTime;
}
function _temp3(state_1) {
  return state_1.editEmoji;
}
function _temp2(state_0) {
  return state_0.editText;
}
function _temp(state) {
  return state.editingTodoId;
}